import { Box, Paper, Typography } from "@mui/material";
import { alpha } from "@mui/material/styles";

export default function FeatureCard({ Icon, title, desc }) {
  return (
    <Paper
      elevation={0}
      variant="outlined"
      sx={{
        position: "relative",
        height: "100%",
        p: { xs: 2, md: 2.5 },
        borderRadius: 1, // ⬅️ أصغر
        display: "grid",
        alignContent: "start",
        gap: 1.25,
        bgcolor: "common.white",
        boxShadow: "0 10px 28px rgba(8, 28, 78, .06)",
        transition: "transform .2s, box-shadow .2s, border-color .2s",
        "&:hover": {
          transform: "translateY(-3px)",
          boxShadow: "0 12px 36px rgba(8, 28, 78, .10)",
          borderColor: "primary.main",
        },
      }}
    >
      <Box
        sx={(theme) => ({
          width: 40,
          height: 40,
          borderRadius: 0.5,
          display: "grid",
          placeItems: "center",
          flexShrink: 0,
          bgcolor: alpha(theme.palette.primary.main, 0.05), // خلفية خفيفة
          color: "primary.main",
          border: "1px solid",
          borderColor: "divider",
        })}
      >
        <Icon fontSize="small" />
      </Box>

      <Typography
        component="h3"
        sx={{
          fontWeight: 900,
          fontSize: { xs: 17, md: 18 },
          color: "primary.dark",
          textDecoration: "none", // ⬅️ بدون خط
          "&:hover": { textDecoration: "none" }, // ⬅️ حتى عند الهوفر
        }}
      >
        {title}
      </Typography>

      <Typography color="text.secondary" sx={{ lineHeight: 1.9 }}>
        {desc}
      </Typography>
    </Paper>
  );
}
